/**
 * @desc 判断是否为 RTL 模式
 * @param list
 */
export function isRTL(): boolean {
    return document.documentElement.classList?.contains('display-rtl')
}
